import { userState } from "@/stores/user";
import { state as azureAd } from "@/stores/azure-ad";
import { TENANT_EMSMC } from "@/lib/azure";

import LoginPage from "@/pages/login/LoginPage.vue";
import ResetPasswordPage from "@/pages/reset-request/ResetPasswordPage.vue";
import UserPage from "@/pages/user/UserPage.vue";
import PendingActionsPage from "@/pages/pending-actions/PendingActionsPage.vue";
import ConfirmResetPasswordPage from "@/pages/reset-request/ConfirmResetPasswordPage.vue";
import ConfirmSetupPasswordPage from "./pages/reset-request/ConfirmSetupPasswordPage.vue";

export default [
    {
        path: '',
        redirect: () => azureAd.key ? `/${azureAd.key}/login` : '/login',
    },
    {
        path: '/site/index',
        redirect: () => azureAd.key ? `/${azureAd.key}/login` : '/login',
    },
    {
        path: '/:tenant(emsmc|cone-health)?/login',
        component: LoginPage,
        beforeEnter: (to) => {
            if (userState.isLoggedIn) {
                return { path: '/user' };
            }

            to.params.tenant = to.params.tenant || TENANT_EMSMC;
        }
    },
    { path: '/pending-actions', component: PendingActionsPage },
    { path: '/reset-request', component: ResetPasswordPage },
    { path: '/confirm-reset-request', component: ConfirmResetPasswordPage },
    { path: '/confirm-setup-request', component: ConfirmSetupPasswordPage },
    { path: '/user', component: UserPage },
    {
        path: '/:pathMatch(.*)', beforeEnter: () => {
            return { path: '' }
        }
    }
];